import { render, staticRenderFns } from "./OpinionFamilyListTab.vue?vue&type=template&id=8044888a&scoped=true&lang=pug"
import script from "./OpinionFamilyListTab.vue?vue&type=script&lang=ts"
export * from "./OpinionFamilyListTab.vue?vue&type=script&lang=ts"
import style0 from "./OpinionFamilyListTab.vue?vue&type=style&index=0&id=8044888a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8044888a",
  null
  
)

export default component.exports